import DataCard from "./DataCard";

export default DataCard;
